import { createAsyncThunk } from "@reduxjs/toolkit";
import { dataServer, fetchDummyData, isProduction } from "~/constants";
import { fetchOrganizationData, fetchOrganizationInfoData, fetchOrganizationtechInfoData } from "~/slices/demiData";
import { updatePromise } from "./updateThunks";
import type { Organization } from "~/types/general";
import type { CurrentUser } from "~/types/roles";

// Async thunk to fetch organization data
export const createOrganization = createAsyncThunk(
  "organization/createOrganization",
  async ({org, user}: { org: Partial<Organization>, user: Partial<CurrentUser> }, { rejectWithValue }) => {
    
    let time = new Date().getTime();
    try {
      const response = await fetch(`${dataServer}organizations`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ org, user }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch organization");
      }
      time = new Date().getTime() - time;
      // console.log("createOrganization time", time);
      return await response.json();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


